import { Pipe, PipeTransform } from '@angular/core';

/**
 * `1536` → `1,5 Ko` : la taille d'un fichier telle qu'on la lit.
 *
 * Usage : `{{ bytes | fileSize }}`. Vide pour zéro ou absent — une pièce
 * sans taille connue n'affiche rien plutôt que « 0 o ».
 */
@Pipe({ name: 'fileSize', standalone: true })
export class FileSizePipe implements PipeTransform {
  private static readonly units = ['o', 'Ko', 'Mo', 'Go'];

  transform(bytes: number | null | undefined): string {
    if (!bytes) return '';
    let value = bytes;
    let unit = 0;
    while (value >= 1024 && unit < FileSizePipe.units.length - 1) {
      value /= 1024;
      unit++;
    }
    const shown = unit === 0 ? String(value) : value.toFixed(1).replace('.', ',');
    return `${shown} ${FileSizePipe.units[unit]}`;
  }
}
